export default __webpack_public_path__ + "images/plot-type-stacked-line.bdd6a202ed29dc39513cfb84a97e014c.svg";